// templates/report-templates-registry.ts
import { reportAiExposureAdoption } from './report-ai-exposure-adoption';
import { reportCompanyAttrition } from './report-company-attrition';
import { reportCompanyCompensationBenchmark } from './report-company-compensation-benchmark';
import { reportCompanyGenderDiversity } from './report-company-gender-diversity';
import { reportMarketConditions } from './report-company-market-conditions';
import { reportCompanyOverview } from './report-company-overview';
import { reportCompanySentiment } from './report-company-sentiment';
import { reportOrgHealth } from './report-org-health';

export const REPORT_TEMPLATES = {
  'report-ai-exposure-adoption': reportAiExposureAdoption,
  'report-company-overview': reportCompanyOverview,
  'report-company-attrition': reportCompanyAttrition,
  'report-company-sentiment': reportCompanySentiment,
  'report-org-health': reportOrgHealth,
  'report-company-compensation-benchmark': reportCompanyCompensationBenchmark,
  'report-company-gender-diversity': reportCompanyGenderDiversity,
  'report-company-market-conditions': reportMarketConditions,
} as const;

type ReportTemplateId = keyof typeof REPORT_TEMPLATES;

export const getLocalReportTemplate = (id: string) => {
  return REPORT_TEMPLATES[id as ReportTemplateId];
};

export const getAllReportTemplates = () => {
  return Object.values(REPORT_TEMPLATES);
};
